import * as React from 'react'
import { connect } from 'react-redux'

import { waypointSeen } from 'common/actions'
import { Waypoints } from 'embed/constants'
import { MultiProductState } from 'embed/reducers'

interface OwnProps {
  name: Waypoints
}

interface DispatchProps {
  dispatchWayPointSeen: (name: Waypoints) => void
}

interface StoreProps {
  childRect?: {
    bottom: number
    height: number
    left: number
    right: number
    top: number
    width: number
  }
  parentRect?: {
    height: number
    width: number
  }
  seen: boolean
  automatedScrolling: boolean
}

type Props = OwnProps & DispatchProps & StoreProps

const Waypoint: React.FC<Props> = (props) => {
  const point = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (point.current !== null && props.childRect && props.parentRect) {
      // Check if is visible
      const pointTop = point.current.getBoundingClientRect().top
      const topFromViewport = pointTop + props.childRect?.top
      const isVisible = topFromViewport > 0 && props.parentRect?.height > topFromViewport
      if (isVisible && !props.seen && !props.automatedScrolling) {
        props.dispatchWayPointSeen(props.name)
      }
    }
  }, [point, props.childRect, props.parentRect, props.name, props.seen, props.automatedScrolling])

  return <div ref={point} style={{ height: '0px' }} />
}

export const mapStateToProps = (state: MultiProductState, ownProps) => {
  const waypoints = state.waypoints
  return {
    automatedScrolling: waypoints.automatedScrolling,
    childRect: waypoints.childRect,
    parentRect: waypoints.parentRect,
    seen: waypoints.seen[ownProps.name],
  }
}

export const mapDispatchToProps = (dispatch) => ({
  dispatchWayPointSeen: (name) => dispatch(waypointSeen(name)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Waypoint)
